<template>
  <div>
    <!-- <div class="banner"></div> -->

    <!-- $ 商品列表 模块 -->
    <div class="goods-box">
      <div class="wrap">
        <div class="item" 
        :class="{'active-item':show&&item==1}"
        v-for="(item) in 10" :key="item"
        @mouseenter="showGoodsDetail()"
        @mouseleave="hideGoodsDetail()"
        @click="goDetail()">
          <img class="goods-img" src="" >
          <div class="intro">
            <div class="title">
              【10包起拍】重庆佳仙老火锅 底料独立包装底料独立包火料独立包装底料独立包火
            </div>
            <div class="sale">
              今日已成交 <span>892</span> 件
            </div>
            <div class="price">
              <div class="price-item">
                <div class="num">1.5</div>
                <div class="txt">到手价</div>
              </div>
              <div class="price-item">
                <div class="num">20%</div>
                <div class="txt">高佣</div>
              </div>
              <div class="price-item">
                <div class="num">0.3</div>
                <div class="txt">佣金</div>
              </div>
            </div>
          </div>
          <!-- 详情，隐藏 -->
          <div class="detail" v-show="show&&item==1">
            <div class="line"></div>
            <div class="d-1">
              <div>销量：24h <span>1234</span> | 30天 <span>1234</span></div>
              <div>时间：2022-02-22~2022-05-22</div>
              <div>团长：小食代</div>
              <div>店铺：小鹏食品旗舰店</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        show: false
      }
    },
    methods: {
      // $ 商品列表 模块
      // 显示商品详情
      showGoodsDetail() {
        console.log('显示商品详情');
        this.show=true
      },
      hideGoodsDetail(){
        this.show=false
      },
      goDetail(){
        this.$router.push({
          path:'/goodsDetail'
        })
      }
    }
  }
</script>
<style>
body{
  background-color: #f5f7fa;
}
</style>
<style lang="scss" scoped>
.wrap{
  width: 1720px;
  margin: 0 auto;
  padding-top: 20px;
}

.banner{
  // width: 1920px;
  width: 100%;
  height: 200px;
  background-color: pink;
  background: url('https://static.leitool.com/shequntui/bc-douyin/goodsAll/img_banner_one%402x.png') no-repeat; 
  background-size: cover;
  background-position: 50%;
  overflow: hidden;
}

// $ 商品列表 模块
.goods-box{
  .wrap >.item{
    display: inline-block;
    width: 270px;
    // height: 348px;
    background: #fff;
    border-radius: 4px;
    margin-right: 20px;
    margin-bottom: 20px;
    position: relative;
    .goods-img{
      width: 270px;
      height: 270px;
      background: #ADADAD;
      border-radius: 4px;
    }
    .intro{
      height: 154px;
      .title{
        width: 230px;
        margin: 0 auto;
        font-size: 14px;
        color: #45474D;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
      }
      .sale{
        width: 246px;
        height: 40px;
        background: #F5F7FF;
        border-radius: 6px;
        margin: 10px auto;
        font-size: 14px;
        color: #45474D;
        display: flex;
        justify-content: center;
        align-items: center;
        span{
          font-size: 18px;
          color: #5E82FE;
          font-weight: bold;
        }
      }
      .price{
        margin-top: 20px;
        .price-item{
          width: 33%;
          display: inline-block;
          text-align: center;
          line-height: 1;
          font-size: 12px;
          font-weight: bold;
          .num{
            color: #FE2C55;
            margin-bottom: 12px;
            font-size: 13px;
          }
          .txt{
            color: #808A9D;
          }
        }
      }
    }
    // 详情，隐藏
    .detail{
      width: 270px;
      height: 126px;
      position: absolute;
      left: 0;
      bottom:-122px;
      z-index: 100;
      background-color: #fff;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
      box-shadow: 0px 4px 10px 0px #DDDDDD;
      .line{
        width: 235px;
        height: 0;
        background: #EEEEEE;
        box-shadow: 0px 4px 10px 0px #DDDDDD;
        border-top: 1px dashed #DDDDDD;
        margin: 0 auto;
        margin-bottom: 16px;
      }
      .d-1{
        width: 235px;
        margin: 0 auto;
        font-size: 12px;
        color: #808A9D;
        line-height: 1;
        >div{
          margin-bottom: 15px;
        }
        >div:first-child{
          span{
            color: #FE2C55;
          }
        }
      }
      .shop{
        line-height: 1;
        text-align: center;
        // font-family: MicrosoftYaHei;
        .tit{
          font-size: 12px;
          color: #333333;
          margin-bottom: 18px;
        }
        .shop-score{
          .item{
            display: inline-block;
            width: 33%;
            .txt{
              font-size: 12px;
              color: #333333;
              margin-bottom: 9px;
            }
            .num{
              font-size: 12px;
              color: #FF4040;
            }
          }
        }
      }
    }
    // 商品操作，隐藏
    .buy-box{
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 222px;
      padding: 0 4px;
      position: absolute;
      top: 182px;
      left: 0;
      >div{
        display: inline-block;
        border-radius: 4px;
      }
      .l{
        width: 32px;
        height: 32px;
        background: #FEFEFE;
        border-radius: 4px;
      }
      .c{
        width: 91px;
        height: 32px;
        background: #FFFFFF;
        border-radius: 4px;
        font-size: 13px;
        color: #FE2C55;
        line-height: 32px;
        text-align: center;
      }
      .r{
        width: 91px;
        height: 32px;
        background: #FE2C55;
        border-radius: 4px;
        font-size: 13px;
        color: #FEFEFE;
        line-height: 32px;
        text-align: center;
      }
    }
  }
  .item:nth-child(6n){
    margin-right: 0;
  }
  .active-item{
    box-shadow: 0px 4px 10px 0px #DDDDDD;
  }
}

</style>